import Collection from '../../ModelBinding/Collection';
import Role from './Role';
import Permission from '../Permission/Permission';
import PermissionCollection from '../Permission/PermissionCollection';
import { uniqBy } from 'lodash';

export default class RoleCollection extends Collection<Role> {
  private _permissions?: string[];

  static getModel() {
    return Role;
  }

  get permissions() {
    if (['development', 'test'].includes(process.env.NODE_ENV || '')) {
      console.error('roles.permissions is deprecated and should not be used anymore, use roles.permission_names.');
    }
    const permissions: Permission[] = [];
    this.forEach(role => {
      if (!role.permissions) return;
      role.permissions.forEach(permission => {
        permissions.push(permission);
      });
    });

    return new PermissionCollection({
      data: uniqBy(permissions, permission => permission.getKey()).map(permission =>
        permission.jsonSerialize(),
      ),
    });
  }

  get permission_names() {
    if (this._permissions === undefined) {
      const permissions = this
        .reduce((permissions, role) => [
          ...permissions,
          ...(role.permissions || []).map(({ name = undefined }) => name),
        ], [])
        .filter(Boolean) as string[];
      this._permissions = [...new Set(permissions)];
    }
    return this._permissions;
  }
}
